import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import useAutoAllocateButton from './useAutoAllocateButton';

const styles = theme => ({
  root: {},
  circularProgressIcon: {
    margin: theme.spacing(2),
  },
});

const AutoAllocateAllButton = ({
  className,
  classes,
  onSuccess,
  dialogProps,
}) => {
  const { handleClickAutoAllocate, isAutoAllocating } = useAutoAllocateButton({ onSuccess });

  const {
    title,
    message,
    cancelLabel,
    confirmLabel,
  } = dialogProps;

  const {
    dialogOpen,
    loading,
    handleClose,
    handleSubmit,
    handleOpen,
  } = useConfirmationDialogState({
    onSubmit: handleClickAutoAllocate,
    closeOnSubmit: true,
  });

  return (
    <Box className={classNames(classes.root, className)}>
      {isAutoAllocating
        ? <CircularProgress color="primary" size={24} className={classes.circularProgressIcon} /> : (
          <FDSecondaryActionButton
            loading={isAutoAllocating}
            onClick={handleOpen}
            label={'Clear Manual Allocations'}
            size={'sm'}
          />
        )}

      {dialogOpen && (
        <NewDialog
          title={title}
          message={message}
          cancelLabel={cancelLabel}
          confirmLabel={confirmLabel}
          confirmButtonType="success"
          loading={loading}
          onConfirm={handleSubmit}
          onCancel={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          onClose={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          showCloseIcon={false}
        />
      )}
    </Box>
  );
};

AutoAllocateAllButton.defaultProps = {
  className: '',
  dialogProps: {},
};

AutoAllocateAllButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onSuccess: PropTypes.func.isRequired,
  dialogProps: PropTypes.object,
};

export default withStyles(styles)(AutoAllocateAllButton);
